module.exports = __webpack_public_path__ + "fonts/Wagdie_Fraktur_36-Regular.0820588f.ttf";